module.exports = "<app-header></app-header>\n\n<router-outlet></router-outlet>\n\n<client-strip></client-strip>\n\n<app-footer></app-footer>\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/dev-man/Kgwetlwo-app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main